"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _reduxoptimisticui = require('redux-optimistic-ui');


var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _lodash = require('lodash');
var _utils = require('shared/store/utils');

var _broadcast = require('shared/enum/broadcast');





const initialState = {}

const reducer = _utils.createReducer.call(void 0, 
  initialState,
  builder => {
    builder.addCase(_actionCreators2.default.findCampaignMessagesActions.REQUEST, () => initialState)

    ;[
      _actionCreators2.default.findCampaignMessagesActions.SUCCESS,
      _actionCreators2.default.loadCampaignMessagesPageActions.SUCCESS,
    ].forEach(t => builder.addCase(
      t,
      (s, a) => { a.payload.Messages.forEach(m => s[m.PatientKey] = m) },
    ))

    builder.addCase(
      _actionCreators2.default.removePatientsFromCampaignActions.REQUEST,
      (s, a) => _lodash.omit.call(void 0, s, a.payload.PatientKeys),
    )

    builder.addCase(
      _actionCreators2.default.dequeuePatientsInCampaignActions.REQUEST,
      (s, a) => {
        a.payload.PatientKeys.forEach(patientKey => {
          const msg = s[patientKey]
          if (!msg) return
          msg.Status = _broadcast.broadcastMsgStatus.NOT_SCHEDULED
        })
      },
    )

    // A progress update carries status, not values: a recipient's values are
    // fixed once imported (D7), and senders on older code omit them. Keep
    // the ones already loaded rather than blanking the variable columns.
    builder.addCase(
      _actionCreators2.default.campaignProgressNotificationAction,
      (s, a) => {
        a.payload.Messages.forEach(m => {
          const hasValues = m.TemplateData && Object.keys(m.TemplateData).length > 0
          s[m.PatientKey] = hasValues ? m : { ...m, TemplateData: _nullishCoalesce(_optionalChain([s, 'access', _ => _[m.PatientKey], 'optionalAccess', _2 => _2.TemplateData]), () => ( {})) }
        })
      },
    )

    builder.addCase(_actionCreators2.default.logoutAction, () => initialState)

    builder.addDefaultCase(s => s)
  },
)

exports. default = _reduxoptimisticui.optimistic.call(void 0, reducer)
